import api from './api';

export const getVenditeContatti = async (cantiereId, months = 6) => {
  const res = await api.get(`/dashboard/${cantiereId}/vendite-contatti?months=${months}`);
  return res.data;
};
